import * as React from 'react'
import { IMultiLocationInventory, ILocation } from '@getgreenline/homi-shared'
import { ViewInventoryRow } from './ViewInventoryRow'
import { Skeleton } from 'antd'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  companyId: number
  hasEditProductPermissions: boolean
  multiLocationInventories?: IMultiLocationInventory[]
  showCategory: boolean

  showBrand: boolean
  showLowStockQuantity: boolean
  viewInventoryLocations: ILocation[]
  selectedLocationIds: number[]
  reload: () => void
}

@inject('currentCompanyStore')
export class ActiveInventoryTable extends React.Component<Props, {}> {
  render() {
    const { viewInventoryLocations } = this.props

    if (!this.props.multiLocationInventories) {
      return <Skeleton active />
    }

    const {
      companyId,
      hasEditProductPermissions,
      multiLocationInventories,
      showCategory,
      showBrand,
      showLowStockQuantity,
      selectedLocationIds,
    } = this.props

    let locationsToDisplayInHeader: ILocation[] = []
    let selectedLocationInventories: IMultiLocationInventory[] = []

    locationsToDisplayInHeader = viewInventoryLocations.filter((location) =>
      selectedLocationIds.includes(location.id),
    )
    selectedLocationInventories = [...multiLocationInventories]
    multiLocationInventories.forEach((inventoryItem, index) => {
      const selectedInventories = inventoryItem.inventories.filter((inventory) =>
        selectedLocationIds.includes(inventory.locationId),
      )
      selectedLocationInventories[index].inventories = selectedInventories
    })

    return (
      <div className='table-responsive'>
        <table className='table' id='view-inventory-table'>
          <thead className='thead-light'>
            <tr>
              <th style={{ width: 70 }}>Image</th>
              <th style={{ width: '15em' }}>Product</th>
              <th style={{ width: '15em' }}>SKU</th>
              {showCategory && <th style={{ width: '10em' }}>Category</th>}
              {showBrand && <th style={{ width: '10em' }}>Brand</th>}
              {locationsToDisplayInHeader.map((location) => {
                return (
                  <th className='text-right' key={location.id}>
                    {location.name}
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {selectedLocationInventories.map((multiLocationInventory) => {
              return (
                <ViewInventoryRow
                  companyId={companyId}
                  hasEditProductPermissions={hasEditProductPermissions}
                  key={multiLocationInventory.product.id}
                  multiLocationInventory={multiLocationInventory}
                  onUpdate={() => this.props.reload()}
                  showCategory={showCategory}
                  showBrand={showBrand}
                  showLowStockQuantity={showLowStockQuantity}
                />
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}
